import Meta from '@src/components/Meta';
import NewsTemplate from '@src/components/Template/News';
import PageTemplate from '@src/components/Template/Page';
import { metaInfo } from '@src/data/meta';
import React from 'react';

const index = () => {
  const { title, description, ogImage } = metaInfo.news;
  return (
    <>
      <PageTemplate
        AsideIsListPage={true}
        AsideDisabledBody={false}
        AsideDisabledTop={true}
        href={'/news'}
        mainText={'언론보도'}
      >
        <Meta title={title} description={description} ogImage={ogImage} />
        <NewsTemplate />
      </PageTemplate>
    </>
  );
};
export default index;
